<template>
  <div class="page-wrapper">
    <Input placeholder="项目名称" class="mb16 inputwidth"
           v-model="projectName"
           @on-change="inputChange"
    /> <br>
    <Button  type="primary" @click.stop="toAdd" v-p="{api:'posSetting/addPos'}">添加</Button>
    <table-list
      class="mt20"
      title="" :columns="columns" :data="data"
      :loading="loading" :total="total" :current="current"
      @change-page="changePage"
    ></table-list>
    <add :n="addN" :projectList="projectList" @done="posList"></add>
    <update :n="updateN" :projectList="projectList" :fid="fid" @done="posList"></update>
  </div>
</template>
<script>
  import TableList from "components/TableList/index";
  import Add from './components/Add'
  import {posList,deletePos} from "../../../api/accountConfig";
  import {getProjects} from "../../../api/common";
  import Update from './components/Update'

  export default {
    name: "acountlist",
    components:{
      TableList,
      Add,
      Update
    },
    data(){
      return {
        fid:'',
        updateN:0,
        projectList:[],
        projectName:'',
        addN:0,
        current: 1,
        total: 0,
        columns:[
          {
            type:'index',
            width:60,
            align:'center'
          },
          {
            title:' '
          },
          {
            title: "项目名称",
            key: "projectName",
            align: "center",
            width: 160
          },
          
           {
            title:' '
          },
          {
            title: "银行名称",
            key: "bankName",
            align: "center",
            width:200
          },
          {
            title:' '
          },
          {
            title: "账户",
            key: "accountNo",
            align: "center",
            width:180
          },
           {
            title:' '
          },
          {
            title: "POS终端号",
            key: "terminalNo",
            align: "center",
            width:120
          },
           {
            title:' '
          },
          {
            title: "参考号位数",
            key: "referenceNum",
            align: "center",
            width:100
          },
           {
            title:' '
          },
          {
            title: "操作",
            key: "action",
            align: "center",
            fixed:'right',
            width:150,
            render:(h,params)=>{
              let update=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'posSetting/updatePos'
                    }
                  }
                ],
                style:{
                  marginRight:'10px'
                },
                on:{
                  click:()=>{
                    this.fid=params.row['fid']
                    this.updateN++
                  }
                }
              },'修改')
              let deleteItem=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'posSetting/deletePos'
                    }
                  }
                ],
                style:{
                  marginRight:'10px'
                },
                on:{
                  click:()=>{
                    this.deleteItem(params.row['fid'])
                  }
                }
              },'删除')
              return h('div',{},[
                update,deleteItem
              ])
            }
          },
        ],
        data:[],
        loading: false,
        page:1,
        limit:10,
      }
    },
    methods:{
      deleteItem(fid){
        this.$Modal.confirm({
          title:'收款账户删除',
          content:'<p>确认删除本条记录？</p>',
          onOk:()=>{
            let params={
              fid:fid
            }
            deletePos(params).then(res=>{
              this.$Message.success('删除账户成功')
              this.current=1
              this.page=1
              this.posList()
            }).catch(error=>{})
          }
        })
      },
      inputChange(){
        this.current=1
        this.page=1
        this.data=[]
        this.posList()
      },
      posList(){
        let params={
          page:this.page,
          limit:this.limit,
          projectName:this.projectName
        }
        posList(params).then(res=>{
          res.data.rows && (this.data=res.data.rows)
          this.total=res.data.total
        }).catch(error=>{})
      },
      toAdd(){
        this.addN++
      },
      changePage(n){
        this.current=n
        this.page=n
        this.posList()
      },
    },
    created(){
      this.posList()
      getProjects().then(res=>{
        this.projectList=res.data
      }).catch(error=>{})
    }
  }
</script>

<style scoped>
  .inputwidth{
    width: 300px;
  }

</style>
